import get from 'lodash-es/get';

/**
 * @returns {Boolean} `true` when  give view is in zoomout.
 */
export const zoomout = ({state, pageId, pageType}) => get(state, `zoomout-view.${pageType === 'VIEW' ? 'views': 'boards'}.${pageId}`, false);